var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Header"),
      _vm._v(" "),
      _c("div", { attrs: { id: "main" } }, [
        _c("div", { staticClass: "container" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("article", { staticClass: "assista-video" }, [
            _c("h4", [_vm._v("Assista ao vídeo")]),
            _vm._v(" "),
            _c("div", { staticClass: "video" }, [
              _c("div", { staticClass: "embed-container" }, [
                _c("iframe", {
                  attrs: {
                    src: _vm.video,
                    frameborder: "0",
                    allowfullscreen: ""
                  }
                })
              ])
            ])
          ]),
          _vm._v(" "),
          _c("article", { staticClass: "primeiro-passo" }, [
            _c("h4", [_vm._v("Primeiro passo")]),
            _vm._v(" "),
            _c("h1", [_vm._v("Cadastre sua Organização Social")]),
            _vm._v(" "),
            _c("p", [
              _vm._v("Nosso sistema é simples e fácil. Conte sua história!")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "pass" }, [
              _c("img", { attrs: { alt: "Video", src: _vm.pass1 } })
            ])
          ]),
          _vm._v(" "),
          _c("article", { staticClass: "primeiro-passo" }, [
            _c("h4", [_vm._v("Segundo passo")]),
            _vm._v(" "),
            _c("h1", [_vm._v("Compartilhe e divulgue")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Tornamos simples compartilhar seu projeto no Facebook e e-mail."
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "pass" }, [
              _c("img", { attrs: { alt: "Video", src: _vm.pass3 } })
            ])
          ]),
          _vm._v(" "),
          _c("article", { staticClass: "primeiro-passo" }, [
            _c("h4", [_vm._v("Terceiro passo")]),
            _vm._v(" "),
            _c("h1", [_vm._v("Receba doações facilmente")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Receba as doações através de diferentes meios de pagamento"
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "facil" }, [
              _c("img", { attrs: { alt: "Video", src: _vm.pass4 } })
            ])
          ]),
          _vm._v(" "),
          _c("article", { staticClass: "primeiro-passo" }, [
            _c("h4", [_vm._v("Quarto passo")]),
            _vm._v(" "),
            _c("h1", [_vm._v("Atualize seus seguidores")]),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "pass" }, [
              _c("img", { attrs: { alt: "Video", src: _vm.pass2 } })
            ])
          ]),
          _vm._v(" "),
          _c(
            "article",
            { staticClass: "how-btm text-center" },
            [
              _c("h1", [_vm._v("Cadastre sua Organização Social")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Diferentemente de outras plataformas de doação, a nossa é totalmente gratuita. Queremos garantir que toda doação vá direto a quem mais precisa."
                )
              ]),
              _vm._v(" "),
              _c("router-link", { attrs: { to: "/login" } }, [
                _vm._v("Cadastre Agora")
              ])
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("Footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", { staticClass: "how-top text-center" }, [
      _c("h1", [_vm._v("Como Funciona")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Somos uma plataforma online e GRATUITA feita para promover o bem. Você pode ajudar ou buscar ajuda para arrecadar doações à uma causa."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "Deixe seus doadores sempre atualizados com novidades e o progresso de sua Organização Social. "
      ),
      _c("br"),
      _vm._v("Eles gostam de saber que ajudaram :)")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4fd998ea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fd998ea","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AboutUs.vue
// module id = null
// module chunks = 